import React from "react";
import './blog.css';

const Blog = () => {
  const blogs = [
    {
      id: 1,
      title: "Professional Info Card Design HTML CSS: Complete Tutorial with Source Code (2026) - Codingwithssr",
      img: "Professional-Card-Info-Design-sivaraj47.github.io.png",
      url: "https://codingwithssr.vercel.app/professional-info-card-design",
      brief: "Create Stunning Responsive Card Layouts in Minutes - Free Template & Code, Looking to create professional, eye-catching info cards for your website? This comprehensive tutorial walks you through building a fully responsive card design using pure HTML and CSS with Flexbox. Perfect for blogs, portfolios, service showcases, and modern web applications.",
      livedemo: "View Live Demo -> Technologies: HTML5, CSS3, Flexbox | Author- Sivasundararaj (codingwithssr) | Difficulty- Beginner to Intermediate | Build Time- 15-20 minutes",
      features: [
        "What You'll Build: A modern, professional card layout featuring:"
      ]
    },
    {
      id: 2,
      title: "Login Form Html Css - Codingwithssr",
      img: "Codingwithssr-login-form-Sivasundararaj.png",
      url: "https://sivaraj47.github.io/login-form/",
      brief: "This is a simple login form page showcasing a Login Form Html Css created by Codingwithssr (Sivasundararaj).",
      features: [
        "Built using HTML and CSS only",
        "Fully responsive layout that adapts to different screen sizes",
        "Login Form Html Css design suitable for professional profiles"
      ]
    },
    {
    id: 3,
    title: "Website Design Cost in Trichy: What Businesses Should Expect - Codingwithssr",
    img: "https://images.pexels.com/photos/326518/pexels-photo-326518.jpeg",
    url: "/blog/website-design-cost-in-trichy", // TODO
    brief:
      "A plain guide to what affects website design cost in Trichy, from page count and custom design to e-commerce features, written by Codingwithssr (Sivasundararaj).",
    features: [
      "What changes the price of a business website",
      "Template vs custom design, explained simply",
      "Questions to ask any web design company before you pay",
    ],
  },
    {
    id: 4,
    title: "How to Choose a Web Design Company in Trichy - Codingwithssr",
    img: "https://images.pexels.com/photos/34140/pexels-photo.jpg",
    url: "/blog/how-to-choose-web-design-company-in-trichy", // TODO
    brief:
      "A checklist for Trichy business owners comparing web design companies, covering portfolio, SEO, mobile design, support and contracts.",
    features: [
      "How to judge a portfolio and real client results",
      "Red flags such as copied templates and no post-launch support",
      "What a fair quote and timeline look like",
    ],
  },
  {
    id: 5,
    title: "Local SEO for Trichy Businesses: Get Found on Google - Codingwithssr",
    img: "https://images.pexels.com/photos/68763/pexels-photo-68763.jpeg",
    url: "/blog/local-seo-for-trichy-businesses", // TODO
    brief:
      "Step-by-step local SEO for shops, clinics and service businesses in Trichy: Google Business Profile, reviews, local keywords and website basics.",
    features: [
      "Setting up and verifying a Google Business Profile",
      "Getting genuine Google reviews",
      "On-page SEO your website needs to rank locally",
    ],
  },
  {
    id: 6,
    title: "7 Signs Your Trichy Business Needs a Website Redesign - Codingwithssr",
    img: "https://images.pexels.com/photos/30885764/pexels-photo-30885764.jpeg",
    url: "/blog/website-redesign-signs-trichy", // TODO
    brief:
      "Slow loading, poor mobile layout and no enquiries are signs your website is costing you customers. Learn when to redesign instead of patching.",
    features: [
      "Speed, mobile and security checks you can do yourself",
      "When a redesign pays off compared with small fixes",
      "What to keep, such as URLs, content and rankings",
    ],
  },
  {
    id: 7,
    title: "E-commerce Website Development in Trichy: Shopify vs Custom React - Codingwithssr",
    img: "https://images.pexels.com/photos/326514/pexels-photo-326514.jpeg",
    url: "/blog/ecommerce-website-development-trichy", // TODO
    brief:
      "Which platform fits a Trichy store: a hosted solution like Shopify or a custom React build? Costs, speed, payments and maintenance compared.",
    features: [
      "Payment gateway and delivery options for Indian stores",
      "Cost and flexibility of hosted vs custom builds",
      "How product pages should be set up for Google",
    ],
  },
  ];

  return (
    <div id="blog">
      <h1>My Blog Posts</h1>
      <div className="listidea">
        {blogs.map((blog) => (
          <div className="listbox" key={blog.id}>
            <a
              href={blog.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={blog.img}
                className="imgbox"
                alt={`${blog.title} preview`}
              />
              <h2>{blog.title}</h2>
              <p>{blog.brief}</p>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
